module.exports = __webpack_public_path__ + "img/MYTEC.eaa7e987.png";